<div class="faq-page content-desktop">
  <div class="pasi-card">
    <div class="pasi-title mb-3">
      <span>{{'SI_FAQS_TITLE' | translate}}&nbsp;({{'SI_FAQS' | translate}})</span>
    </div>
    <div class="mt-3">
      <p-accordion [multiple]="true" styleClass="si-accordion_basic">
        <ng-container *ngFor="let item of items; index as index;">
          <p-accordionTab [selected]="false">
            <ng-template pTemplate="header">
              <div>
                <span>{{index + 1}}.&nbsp;</span><span [innerHTML]="item.question | translate"></span>
              </div>
            </ng-template>
            <div>
              <div [innerHTML]="item.response | translate"></div>
            </div>
          </p-accordionTab>
        </ng-container>
      </p-accordion>
    </div>
  </div>
</div>
